import React, { useState, useEffect } from 'react';
import { subscribeToCollection, saveDocument } from '../firebase';
import AssignmentBox from './AssignmentBox';

export default function RoomAssignments({ users = [] }) {
  const [rooms, setRooms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    // Subscribe to Rooms Firestore collection
    const unsubscribe = subscribeToCollection("rooms", (data) => {
      // Sort by ID to keep order clean
      const sorted = [...data].sort((a, b) => {
        if (a.id === 'den') return 1;
        if (b.id === 'den') return -1;
        return a.id.localeCompare(b.id);
      });
      setRooms(sorted);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getNamesList = (str) => {
    return str ? str.split(/[,/&]/).map(n => n.trim()).filter(Boolean) : [];
  };

  const handleAddGuest = async (room, selectedName) => {
    if (!selectedName) return;

    const currentGuests = getNamesList(room.occupant);
    if (!currentGuests.includes(selectedName)) {
      const updatedGuests = [...currentGuests, selectedName];
      const updatedRoom = {
        ...room,
        occupant: updatedGuests.join(", ")
      };
      await saveDocument("rooms", room.id, updatedRoom);
    }
  };

  const handleRemoveGuest = async (room, guestToRemove) => {
    if (!window.confirm(`Are you sure you want to remove ${guestToRemove} from this room?`)) return;
    const currentGuests = getNamesList(room.occupant);
    const updatedGuests = currentGuests.filter(g => g !== guestToRemove);
    const updatedRoom = {
      ...room,
      occupant: updatedGuests.join(", ")
    };
    await saveDocument("rooms", room.id, updatedRoom);
  };

  return (
    <div className="tab-panel">
      <div className="view-title-container" style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="view-title">
          <h2>🛌 Room Assignments</h2>
        </div>
        <button
          className="btn-primary"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '0.85rem',
            padding: '8px 16px',
            borderRadius: '20px',
            cursor: 'pointer',
            background: isEditing ? 'var(--color-accent)' : 'var(--color-primary)'
          }}
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? '✓ Done' : 'Edit Assignments'}
        </button>
      </div>

      <div className="room-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: '6px' }}>
        {isLoading ? (
          <div className="loading-container" style={{ gridColumn: '1 / -1', width: '100%', display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
            <div className="loading-chip">
              <span className="spinner"></span>
              <span>Syncing Room Layouts...</span>
            </div>
          </div>
        ) : rooms.length === 0 ? (
          <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', color: 'var(--color-text-muted)', gridColumn: '1 / -1', width: '100%' }}>
            No rooms found.
          </div>
        ) : (
          rooms.map(room => {
            return (
              <div key={room.id} className="room-card" style={{ padding: '6px 8px', display: 'flex', flexDirection: 'column', gap: '2px', minHeight: 'auto' }}>
                {/* Room Body Details */}
                <div className="room-details" style={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '0.85rem', color: 'var(--color-text-main)', fontWeight: '700', margin: 0 }}>
                      {room.name}
                    </h3>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.7rem', color: 'var(--color-text-muted)' }}>
                    <span style={{ fontWeight: '500' }}>{room.beds}</span>
                  </div>
                </div>

                {/* Assignment Display / Editor */}
                <AssignmentBox
                  label="Guests"
                  selectedIds={room.occupant}
                  users={users}
                  isEditing={isEditing}
                  onAdd={(guestName) => handleAddGuest(room, guestName)}
                  onRemove={(guestName) => handleRemoveGuest(room, guestName)}
                  emptyPlaceholder="Vacant"
                  addPlaceholder="-- Select --"
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
